/**
 * Auth API — login, register, password reset, Google session, OTP, role switching.
 * Definitions live here; `api.js` re-exports for backward-compat.
 */
import client from './client';

export const authAPI = {
  register: async (email, password, role, phone, consent = {}, phoneVerificationToken = null, referralCode = null) => {
    const r = await client.post('/auth/register', {
      email, password, role, phone,
      consent_terms_version: consent.terms_version || null,
      consent_privacy_version: consent.privacy_version || null,
      phone_verification_token: phoneVerificationToken,
      referral_code: referralCode || null,
    });
    return r.data;
  },
  // Public signup phone verification (WhatsApp OTP)
  signupSendWhatsAppOtp: async (phone) => (await client.post('/auth/signup/whatsapp-otp/send', { phone })).data,
  signupVerifyWhatsAppOtp: async (phone, otp) => (await client.post('/auth/signup/whatsapp-otp/verify', { phone, otp })).data,
  // Authenticated change-phone via WhatsApp OTP
  changePhoneSendOtp: async (phone) => (await client.post('/auth/change-phone/whatsapp-otp/send', { phone })).data,
  changePhoneVerifyOtp: async (phone, otp) => (await client.post('/auth/change-phone/whatsapp-otp/verify', { phone, otp })).data,
  getLegalCurrent: async () => (await client.get('/legal/current')).data,
  getLegalVersions: async () => (await client.get('/legal/versions')).data,
  getWhatsAppInfo: async () => (await client.get('/whatsapp/info')).data,
  getMyConsent: async () => (await client.get('/me/consent')).data,
  recordMyConsent: async () => (await client.post('/me/consent')).data,
  login: async (email, password, preferredRole) => {
    const body = { email, password };
    if (preferredRole) body.preferred_role = preferredRole;
    const r = await client.post('/auth/login', body);
    return r.data;
  },
  getMe: async () => (await client.get('/auth/me')).data,
  changePassword: async (currentPassword, newPassword) =>
    (await client.post('/auth/change-password', { current_password: currentPassword, new_password: newPassword })).data,
  forgotPassword: async (email) => (await client.post('/auth/forgot-password', { email })).data,
  resetPassword: async (token, newPassword) =>
    (await client.post('/auth/reset-password', { token, new_password: newPassword })).data,
  googleSession: async (sessionId, role) =>
    (await client.post('/auth/google/session', { session_id: sessionId, role })).data,
  updateEmail: async (email) => (await client.post('/auth/update-email', { email })).data,
  sendEmailVerification: async () => (await client.post('/auth/send-email-verification')).data,
  verifyEmailToken: async (token) => (await client.post('/auth/verify-email-token', { token })).data,
  sendWorkEmailOtp: async (workEmail) => (await client.post('/auth/work-email/send-otp', { work_email: workEmail })).data,
  verifyWorkEmailOtp: async (otp) => (await client.post('/auth/work-email/verify-otp', { otp })).data,
  updatePhone: async (phone) => (await client.post('/auth/update-phone', { phone })).data,
};

export default authAPI;
